import React from 'react'

const TwitterPlugin = () => {
  return (
    <div className='panel panel-primary'>
      <div className='panel-heading'>
        <h2 className='panel-title'>Twitter</h2>
      </div>
      <div className='panel-body text-center' id='sideBarContentForTwitter'>
        <a className='twitter-timeline' href='https://twitter.com/HolidayExtras' data-widget-id='410723792055328768'>Tweets by @HolidayExtras</a>
      </div>
    </div>
  )
}

export default TwitterPlugin



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/destinations/twitterPlugin.jsx